(() => {
  if (window.productAccordionsInitialized) return;
  window.productAccordionsInitialized = true;

  const rootSelector = '[data-specs-block]';
  const roots = new Set();
  const autoOpenedByRoot = new WeakMap();
  const desktopQuery = window.matchMedia('(min-width: 750px)');

  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  function applyDefaultOpen(root) {
    const targetSetting = desktopQuery.matches
      ? root.dataset.openAccordionDesktop
      : root.dataset.openAccordionMobile;
    const targetTitles = (targetSetting || '').split(',').map(normalize).filter(Boolean);
    const accordions = Array.from(root.querySelectorAll('details.custom-details-accordion'));
    const nextAutoOpened = new Set(
      accordions.filter((accordion) => {
        const summary = accordion.querySelector('summary');
        return summary && targetTitles.includes(normalize(summary.textContent));
      }),
    );
    const previousAutoOpened = autoOpenedByRoot.get(root) || new Set();

    previousAutoOpened.forEach((accordion) => {
      if (!nextAutoOpened.has(accordion)) accordion.removeAttribute('open');
    });
    nextAutoOpened.forEach((accordion) => accordion.setAttribute('open', ''));
    autoOpenedByRoot.set(root, nextAutoOpened);
  }

  function registerRoots(container) {
    if (container.matches(rootSelector)) {
      roots.add(container);
      applyDefaultOpen(container);
    }

    container.querySelectorAll(rootSelector).forEach((root) => {
      roots.add(root);
      applyDefaultOpen(root);
    });
  }

  document.querySelectorAll(rootSelector).forEach((root) => {
    roots.add(root);
    applyDefaultOpen(root);
  });

  desktopQuery.addEventListener('change', () => {
    roots.forEach(applyDefaultOpen);
  });

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) registerRoots(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (!(event.target instanceof Element)) return;

    roots.forEach((root) => {
      if (event.target === root || event.target.contains(root)) roots.delete(root);
    });
  });
})();
